import { useContext, useState } from "react"
import UiButton1 from "./ui_button1"
import { AppContext } from "./context"
import { apiUrl, live } from "./delcare"
import UiSpinner from "./ui_spinner"

const ConfirmChangeEmail = () => {

    const { neonUser, token } = useContext(AppContext)

    const [emailSent, setEmailSent] = useState(false)
    const [loading, setLoading] = useState(false)

    const changeEmailHandler = async () => {
        setLoading(true)
        let data = {
            "email_to": neonUser.email,
            "user_id": neonUser.user_id,
            "live": live
        }

        let url = `${apiUrl}/send_email_change`

        let resp = await fetch(url, {
            method: "POST",
            headers: (() => {
                let myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Authorization", "Bearer " + token.accessToken);
                return myHeaders
            })(),
            body: JSON.stringify(data)
        })

        if (!resp.ok) {
            setLoading(false)
            return
        }

        setEmailSent(true)
        setLoading(false)
        return
    }

    return (
        <div className="h-100 d-flex flex-column justify-content-between">
            {emailSent ?
                <p className="poppins text-success">An email with link has been sent to your email address.</p>
                :
                <p className="poppins">Confirm Change Email Address?</p>
            }
            {emailSent ?
                null
                :
                <>
                    {loading ?
                        <UiSpinner />
                        :
                        <UiButton1 text="Continue" submit={changeEmailHandler} />
                    }
                </>
            }
        </div>
    )
}

export default ConfirmChangeEmail